export type StreakWorkflowState = {
  devoId: string | null;
  previousPercentage: number | undefined;
  projectedStreakDay: number | null;
  toastThresholdReached: boolean;
  projectedStreakRequested: boolean;
  toastShown: boolean;
};

export type StreakWorkflowEvent =
  | { type: "devoChanged"; devoId: string | null }
  | { type: "progressObserved"; percentage: number }
  | { type: "completionThresholdCrossed" }
  | { type: "streakLoaded"; projectedStreakDay: number }
  | { type: "streakLoadFailed" }
  | { type: "toastThresholdCrossed" }
  | { type: "toastShown" };

export function createInitialStreakWorkflowState(devoId: string | null = null): StreakWorkflowState {
  return {
    devoId,
    previousPercentage: undefined,
    projectedStreakDay: null,
    toastThresholdReached: false,
    projectedStreakRequested: false,
    toastShown: false,
  };
}

export function reduceStreakWorkflow(state: StreakWorkflowState, event: StreakWorkflowEvent): StreakWorkflowState {
  switch (event.type) {
    case "devoChanged":
      return createInitialStreakWorkflowState(event.devoId);
    case "progressObserved":
      return {
        ...state,
        previousPercentage: event.percentage,
      };
    case "completionThresholdCrossed":
      return {
        ...state,
        projectedStreakRequested: true,
      };
    case "streakLoaded":
      return {
        ...state,
        projectedStreakDay: event.projectedStreakDay,
      };
    case "streakLoadFailed":
      return {
        ...state,
        projectedStreakRequested: true,
      };
    case "toastThresholdCrossed":
      return {
        ...state,
        toastThresholdReached: true,
      };
    case "toastShown":
      return {
        ...state,
        toastShown: true,
      };
  }
}

export function shouldRequestProjectedStreak(state: StreakWorkflowState): boolean {
  return state.projectedStreakRequested === false;
}

export function shouldShowStreakToast(state: StreakWorkflowState): boolean {
  return state.toastThresholdReached && state.projectedStreakDay !== null && state.toastShown === false;
}
